import {lazy} from 'react';

const AppointmentsManagement = lazy(() => import('./AppointmentsManagement'));

export default AppointmentsManagement;
